<template>
  <div class="full-page">
    <md-toolbar v-if="!isPhone" md-elevation="0" class="md-transparent md-toolbar-absolute">
      <div class="md-toolbar-row md-offset">
        <div class="md-toolbar-section-end">
          <md-button :class="{ toggled: $sidebar.showSidebar }"
            class="md-just-icon md-simple md-round md-toolbar-toggle" @click="toggleSidebar">
            <span class="icon-bar" />
            <span class="icon-bar" />
            <span class="icon-bar" />
          </md-button>

          <div :class="{ 'off-canvas-sidebar': responsive }" class="md-collapse">
            <md-list>
              <md-list-item href="#" @click.prevent="doctorSearch">
                <i class="fas fa-user-md" />&nbsp; Search
              </md-list-item>

              <md-list-item href="#" @click.prevent="register">
              Register
              <md-icon>person_add</md-icon></md-list-item>

              <!-- <md-list-item href="#" @click.prevent="showSwal('drreg-confirmation')">
                <md-icon>person_add</md-icon>Register Doctor
              </md-list-item>

              <md-list-item href="#" @click.prevent="showSwal('ptreg-confirmation')">
                <md-icon>person_add</md-icon>Register Patient
              </md-list-item> -->

              <md-list-item v-if="!loggedIn" href="#" @click.prevent="login">
                <md-icon>fingerprint</md-icon>login
              </md-list-item>

              <md-list-item v-else href="#" @click.prevent="logout">
                <md-icon>logout</md-icon>logout
              </md-list-item>
            </md-list>
          </div>
        </div>
      </div>
    </md-toolbar>

    <div class="wrapper wrapper-full-page" @click="toggleSidebarPage">
      <div :class="setPageClass" :style="setBgImage" class="page-header header-filter" filter-color="black">
        <md-menu v-if="isPhone" class="phone-menu" md-size="small" md-direction="bottom-start"
          style="background-color: transparent">
          <i class="fa fa-bars fa-2x" md-menu-trigger aria-hidden="true" />
          <!-- <md-button md-menu-trigger></md-button> -->
          <md-menu-content>

            <md-menu-item @click.prevent="doctorSearch">
              Search
              <i class="fas fa-user-md shift-icon-left" />
            </md-menu-item>

            <md-menu-item href="#" class="shift-left" @click.prevent="register">
              Register
              <md-icon class="shift-icon-right">person_add</md-icon></md-menu-item>

            <!-- <md-menu-item @click.prevent="showSwal('drreg-confirmation')">
              Register Doctor
              <md-icon class="shift-icon-left">person_add</md-icon></md-menu-item>

            <md-menu-item @click.prevent="showSwal('ptreg-confirmation')">
              Register Patient
              <md-icon class="shift-icon-left">person_add</md-icon></md-menu-item> -->

            <md-menu-item v-if="!loggedIn" href="#" class="shift-left" @click.prevent="login">
              Login
              <md-icon class="shift-icon-right">fingerprint</md-icon></md-menu-item>

            <md-menu-item v-if="loggedIn" href="#" class="shift-left" @click.prevent="logout">
              Logout
              <md-icon class="shift-icon-right">logout</md-icon></md-menu-item>

          </md-menu-content>
        </md-menu>

        <div class="container md-offset">
          <zoom-center-transition :duration="pageTransitionDuration" mode="out-in">
            <router-view />
          </zoom-center-transition>
        </div>


        <authfooter />
      </div>
    </div>
  </div>
</template>
<script>
import { ZoomCenterTransition } from "vue2-transitions";
import authfooter from "./footer.vue";
import Swal from "sweetalert2";
import $ from "jquery";
import img from "@/assets/img/phone_home_slide.jpg";
import axios from 'axios'

export default {
  components: {
    ZoomCenterTransition,
    authfooter,
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black",
    },
  },
  inject: {
    autoClose: {
      default: true,
    },
  },
  data() {
    return {
      user: {
        name: null,
        email: null,
        type: null,
      },
      responsive: false,
      showMenu: true,
      menuTransitionDuration: 250,
      pageTransitionDuration: 300,
      year: new Date().getFullYear(),
      userType: null
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },

    isPhone() {
      if (window.screen.width < 760) {
        return true;
      } else {
        return false;
      }
    },
    screenWidth() {
      return window.screen.width;
    },
    setBgImage() {
      let images = {
        Pricing: "./img/bg-pricing.jpg",
        Login: "./img/home_slide.jpg",
        ResetPsw: "./img/home_slide.jpg",
        ResetPswAction: "./img/home_slide.jpg",
        DoctorSearch: "./img/home_slide.jpg",
        GCRegister:"./img/home_slide.jpg",
        PatientRegistration: "./img/home_slide.jpg",
        'Patient Registration': "./img/home_slide.jpg",
        Lock: "./img/home_slide.jpg", //"./img/lock.jpg"
        "Reading Center": "./img/home_slide.jpg", //"./img/lock.jpg"
        "Search Doctors": "./img/home_slide.jpg", //"./img/lock.jpg"
        "Doctor Registration": "./img/home_slide.jpg", //"./img/register.jpg",
      };
      if (!this.isPhone) {
        return {
          backgroundImage: `url(${images[this.$route.name]})`,
        };
      } else {
        return {
          backgroundImage: `url(${img})`,
        };
      }
    },
    setPageClass() {
      return `${this.$route.name}-page`.toLowerCase();
    },
  },
  watch: {
    loggedIn(newVal, oldVal) {
      this.setVars();
    },
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
    this.setEnvironment();
  },
  updated() {
    this.setEnvironment();
  },
  beforeDestroy() {
    this.closeMenu();
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    toggleSidebarPage() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },

    linkClick() {
      if (
        this.autoClose &&
        this.$sidebar &&
        this.$sidebar.showSidebar === true
      ) {
        this.$sidebar.displaySidebar(false);
      }
    },

    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },

    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    doctorSearch() {
      //console.log("Button clicked.");
      this.$router.push("/");
      this.$router.push("/doctor-search");
    },
    showSwal(type) {
      if (type === "drreg-confirmation") {
        this.$router.push("/");
        //this.toggleSidebar();
        Swal.fire({
          showCancelButton: true,
          confirmButtonClass: "md-button md-primary",
          cancelButtonClass: "md-button md-default",
          confirmButtonText: "Register",
          cancelButtonText: "Cancel",
          buttonsStyling: false,
          html: ` <div align="Left">
                  <div align="Center"><img src="../img/GlobeChek.png" width="150" height="auto"></div>
                  <h5 class="info-text">Welcome Doctor!</h5>
                  <h5>
                    To register with GlobeChek for referrals you must currently be qualified
                    as Ophthalmologist (MD) or equivalent, Optometrist (OD), or Osteopath (DO).
                    <br/><br/>
                    Please complete each of the following sections. Once you have submitted your completed application,
                    you will receive an email with your login credentials and/or additional instructions within 48 hours.
                    <br/><br/>
                    If you experience any problems registering, please contact us at
                    <a href="mailto:info@globechek.com">Info@GlobeChek.com</span>
                  </h5></div>`,
        }).then((result) => {
          if (result.value) {
            this.$router.push("/register-doctor");
          }
        });
      }
      if (type === "ptreg-confirmation") {
        this.$router.push("/");
        //this.toggleSidebar();
        Swal.fire({
          showCancelButton: true,
          confirmButtonClass: "md-button md-primary",
          cancelButtonClass: "md-button md-default",
          confirmButtonText: "Register",
          cancelButtonText: "Cancel",
          buttonsStyling: false,
          html: ` <div align="Left">
                  <div align="Center"><img src="../img/GlobeChek.png" width="150" height="auto"></div>
                  <h5 class="info-text">Welcome to GlobeChek!</h5>
                  <h5>
                    By choosing to be screened by GlobeChek, you are consenting to the use of your 
                    depersonalized information collected by the screening by both GlobeChek and third parties. 
                    All personally identifying information (name, address, phone number, email address, photograph, etc.) 
                    will be removed prior to use or dissemination to a third party. Depersonalized data will be analyzed 
                    in aggregate form by both GlobeChek and third parties for the purpose of statistical analysis of eye 
                    health across demographic populations and to understand the effectiveness of eye screening and treatment 
                    over time. If you do not agree to the use of your depersonalized data, you are not authorized to use 
                    GlobeChek products or services.
                  </h5></div>`,
        }).then((result) => {
          if (result.value) {
            this.$router.push("/register-patient");
          }
        });
      }

    },
    beforeRouteUpdate(to, from, next) {
      // Close the mobile menu first then transition to next page
      if (this.showMenu) {
        this.closeMenu();
        setTimeout(() => {
          next();
        }, this.menuTransitionDuration);
      } else {
        next();
      }
    },

    login() {
      this.$router.push("/");
      this.$router.push("/login");
    },
    logout() {
      this.$store.dispatch("auth/logout")
        .then(() => {
          sessionStorage.clear()
          this.$router.push({ path: "/" })
        })
    },
    register(){
      this.$router.push("/");
      this.$router.push("/gc-register");
    },


    setEnvironment() {
      sessionStorage.clear();
      sessionStorage.setItem("APP_TITLE", process.env.VUE_APP_TITLE);
      sessionStorage.setItem("API_SERVICE", process.env.VUE_APP_URL);

    },

    setVars() {
      sessionStorage.setItem("username", this.user.email);
      sessionStorage.setItem("email", this.user.email)
      this.getMemberInfo();
    },

    getMemberInfo() {
      //debugger
      if (this.loggedIn) {
        var vm = this;
        vm.userType = sessionStorage.getItem("role")
        switch (vm.userType) {
          case "Patient":  // "User"
            sessionStorage.setItem("usertype", "Patient");
            vm.dashSource = "/member-dash/";
            vm.portalRoute = "/portal/member";
            break;
          case "Reader":
          case "Doctor":
            sessionStorage.setItem("usertype", "Reader");
            vm.dashSource = "/reader-dash/";
            vm.portalRoute = "/portal/reader";
            break;
          case "Provider":
          /* Nra
          case "Doctor":
            sessionStorage.setItem("usertype", "Doctor");
            vm.dashSource = "/doctor-dash/";
            vm.portalRoute = "/portal/doctor";
            break;
          */
          case "Admin":
            sessionStorage.setItem("usertype", "Administrator");
            vm.dashSource = "/admin-dash/";
            vm.portalRoute = "/portal/admin";
            break;

          case "Technician":
            sessionStorage.setItem("usertype", "Technician");
            vm.dashSource = "/technician-dash/";
            vm.portalRoute = "/portal/technician";
            break;

          case "Exec":
            sessionStorage.setItem("usertype", "Executive");
            window.location.href = "./roles/executive/Dashboard.html";
            break;

          case "Super":
              sessionStorage.setItem("usertype", "Super")
              vm.portalRoute = "/portal/super-admin";
            break;

          default:
            console.log("gmi_User Type: UNKNOWN");
        }

        // vm.getDashboardInfo(
        //   this.dashSource,
        //   sessionStorage.getItem("username")
        // );

      }
    },

    async getDashboardInfo(route, user) {
      if ((user !== "") && (user !== undefined) && (user !== null)) {
        const url = process.env.VUE_APP_URL + route + user
        const config = { headers: { "Content-Type": "application/json" } };
        const data = null;
        var vm = this;
        await window.axios
          .get(url, data, config)
          .then((r) => r.data)
          .then((response) => {
            vm.updtDash(response);
          })
          .then((response) => {
            vm.$router.push(vm.portalRoute);
          })
          .catch(function (error) {
            vm.status = "An error occurred: " + error;
            console.log(vm.status);
          });
      }
    },

    updtDash(values) {
      var vm = this;
      var res = values.split(",");

      switch (vm.userType) {
        case "Member":
          sessionStorage.setItem("memberMessages", res[0]);
          sessionStorage.setItem("memberReports", res[1]);
          sessionStorage.setItem("memberReferralsCount", res[2]);
          sessionStorage.setItem("memberReferrals", res[3]);
          sessionStorage.setItem("memberReaderDate", res[4]);
          break;
        case "Doctor":
        case "Reader":
          sessionStorage.setItem("readerMessages", res[0]);
          sessionStorage.setItem("readerAvailable", res[1]);
          sessionStorage.setItem("readerHold", res[2]);
          sessionStorage.setItem("readerReports", res[3]);
          break;
        /* Nra
        case "Doctor":
          sessionStorage.setItem("doctorMessages", res[0]);
          sessionStorage.setItem("doctorAvailable", res[1]);
          sessionStorage.setItem("doctorHold", res[2]);
          sessionStorage.setItem("doctorReports", res[3]);
          break;
        */
        case "Administrator":
          sessionStorage.setItem("adminMessages", res[0]);
          sessionStorage.setItem("adminAvailable", res[1]);
          sessionStorage.setItem("adminHold", res[2]);
          sessionStorage.setItem("adminReports", res[3]);
          break;
        case "Care Provider":
          break;
        case "Technician":
          sessionStorage.setItem("technicianMessages", res[0]);
          sessionStorage.setItem("technicianAvailable", res[1]);
          sessionStorage.setItem("technicianHold", res[2]);
          sessionStorage.setItem("technicianReports", res[3]);
          break;
        case "Executive":
          break;
        default:
          console.log("updtDash User Type: UNKNOWN");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$scaleSize: 0.1;
$zoomOutStart: 0.7;
$zoomOutEnd: 0.46;

.phone-menu {
  position: absolute;
  color: white;
  z-index: 999;
  top: 12px;
  right: 12px;
}

.md-list-item-content {
  .md-icon {
    margin-right: 0px;
    margin-left: 13px;
  }
}

.shift-icon-left {
  margin-right: 4px;
}

.shift-icon-right {
  padding-left: 3px;
}

@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  100% {
    opacity: 1;
  }
}

.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}

@keyframes zoomOut8 {
  from {
    opacity: 1;
    transform: scale3d($zoomOutStart, $zoomOutStart, $zoomOutStart);
  }

  to {
    opacity: 0;
    transform: scale3d($zoomOutEnd, $zoomOutEnd, $zoomOutEnd);
  }
}

.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}

.swal2-container {
  margin-left: 200px !important;
}

@media only screen and (max-width: 736px) {
  .phone-hide {
    display: none;
  }

  .full-page .container {
    padding: 10px;
  }
}
</style>
